import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { authorizeUser } from '../../store/index';
import background from '../../assets/Login/loginBackground.png';
import SpinnerHandler from '../../hoc/SpinnerHandler/SpinnerHandler';
import useHttp from '../../hooks/http';
import useForms from '../../hooks/forms';
import CInput from '../../Components/UI/CInput/CInput';
import CButton from '../../Components/UI/FCButton/FCButton';
import {Helmet} from "react-helmet"
import './Login.scss';

const inputs = [
  {
    id: 'username',
    elementConfig: {
      type: 'text',
      placeholder: 'نام کاربری',
    },
    direction: true,
    value: '',
    validation: {
      required: true,
      minLength: 4,
    },
    valid: false,
    touched: false,
  },
  {
    id: 'password',
    elementConfig: {
      type: 'password',
      placeholder: 'رمز عبور',
    },
    direction: true,
    value: '',
    validation: {
      required: true,
      minLength: 4,
    },
    valid: false,
    touched: false,
  },
];

const Login = () => {
  const { clearAll, theForm, formIsValid, onChangeHandler, inputOnBlur, Message, setMessage, findErrorAndShow } =
    useForms();
  const { isLoading, data, error, sendRequest, clear } = useHttp();
  const dispatch = useDispatch();

  useEffect(() => {
    clearAll(inputs);
  }, [clearAll]);

  useEffect(() => {
    if (!isLoading && !error && data) {
      console.log(data);

      if (data.code) {
        setMessage({
          message: data.code,
          type: 'error',
        });
      } else {
        dispatch(
          authorizeUser({
            accessToken: data.access,
            refreshToken: data.refresh,
          })
        );
      }

      clear();
    }
  }, [error, isLoading, data, clear, setMessage, dispatch]);

  const formSubmit = (event) => {
    event.preventDefault();

    if (!formIsValid) {
      findErrorAndShow();
      return;
    }

    const requestBody = {};

    theForm.forEach((element) => {
      requestBody[element.id] = element.requestValue ? element.requestValue : element.value;
    });

    sendRequest('api/token/', 'POST', JSON.stringify(requestBody));
  };

  // return (
  //   <FormsBoilerplate
  //     style={{ background: `url(${background}) no-repeat center center/cover`, width: '80%', height: '100%' }}
  //     inputs={inputs}
  //     url={'api/token/'}
  //     handleResponse={handleResponse}
  //     pageTitle={'ورود'}
  //   />
  // );

  return (
    <SpinnerHandler isLoading={isLoading} showError={Message}>
      <Helmet>
        <title>
          صفحه ورود
        </title>
      </Helmet>
      <div className='login' style={{ background: `url(${background}) no-repeat center center/cover` }}>
        <form className='form' onSubmit={formSubmit}>
          {theForm &&
            theForm.map((input, index) => (
              <CInput
                key={input.id}
                direction={!input.direction && 'rtl'}
                config={input.elementConfig}
                value={input.value}
                validBoxShadow={!input.valid && input.touched}
                changed={(event) => onChangeHandler(event, index)}
                blured={() => inputOnBlur(index)}
              />
            ))}
          {theForm && <CButton ready={formIsValid}>ثبت</CButton>}
        </form>
      </div>
    </SpinnerHandler>
  );
};

export default Login;
